import React, { useEffect, useRef, useState } from 'react'
import { Col, Form } from 'react-bootstrap'
import LabelCustomSmall from '../../../label-custom-small'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import Autocomplete from '../../../custom/autocomplete'
import UseProvinces from '../../../../hooks/use-adds-provinces'
import UseDistricts from '../../../../hooks/use-adds-districts'
import UseSubdistricts from '../../../../hooks/use-adds-subdistricts'
import {
  createErAPI,
  getEmergencyAPI,
  updateErAPI
} from '../../../../services/emergency'
import UseErTypes from '../../../../hooks/use-er-type'
import {
  getDistrictsAPI,
  getSubdistrictsAPI
} from '../../../../services/address'
import InputPhone from '../../../input-phone'
import ButtonSummit from './_btn-summit'
import { useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import CheckUserAdmin from '../../../../helper/check-user-admin'
import SwalCustom from '../../../../alert/swal-custom'
import Error_false from '../../../error/error-false'
import { TXTSUCCESS } from '../../../../Constants'
import Cleave from 'cleave.js/react'
import useNumberInput from '../../../../helper/input-fix-num'

const schema = yup
  .object({
    erName: yup.string().required('โปรดระบุชื่อ-สกุล'),
    erRelationId: yup.object().required('โปรดระบุความสัมพันธ์'),
    erMobilePhone: yup.string().required('โปรดระบุเบอร์โทรศัพท์'),
    erAddress: yup.string().required('โปรดระบุที่อยู่'),
    erSubDistric: yup.object().required('โปรดระบุตำบล/แขวง'),
    erDistric: yup.object().required('โปรดระบุอำเภอ/เขต'),
    erProvince: yup.object().required('โปรดระบุจังหวัด'),
    erPostCode: yup.string().required('โปรดระบุรหัสไปรษณีย์')
  })
  .required()
function EmergencyContact() {
  // let [searchParams, setSearchParams] = useSearchParams()
  // const orgId = searchParams.get('orgId')
  // const code = searchParams.get('code')

  const { profile } = useSelector((state) => state.profileReducer)

  const orgId = profile?.orgId
  const code = profile?.code

  const [dataDetail, setDataDetail] = useState()
  const [isSave, setIsSave] = useState(false)
  const [provincId, setProvincId] = useState(0)
  const [districtId, setDistrictId] = useState(0)
  const provinces = UseProvinces()
  const districts = UseDistricts(provincId)
  const subDistricts = UseSubdistricts(districtId)
  const erTypes = UseErTypes()
  const [isRead, setIsRead] = useState(true)
  const inputRef = useRef(null)
  const handleKeyDownNum = useNumberInput(inputRef)

  const {
    control,
    setError,
    setValue,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })
  const onSubmit = async (data) => {
    const body = {
      orgId,
      code,
      erRelationId: data.erRelationId?.value,
      erName: data.erName,
      erMobilePhone: data.erMobilePhone,
      erHomePhone: data.erHomePhone,
      erAddress: data.erAddress,
      erSubDistric: data.erSubDistric?.label,
      erDistric: data.erDistric?.label,
      erProvince: data.erProvince?.label,
      erPostCode: data.erPostCode
    }

    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to save the changes?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#2C5DFE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSave(true)
        createEr(body)
      }
    })
  }

  const onSubmitEdit = async (data) => {
    const body = {
      erRelationId: data.erRelationId?.value,
      erName: data.erName,
      erMobilePhone: data.erMobilePhone,
      erHomePhone: data.erHomePhone,
      erAddress: data.erAddress,
      erSubDistric: data.erSubDistric?.label,
      erDistric: data.erDistric?.label,
      erProvince: data.erProvince?.label,
      erPostCode: data.erPostCode
    }
    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to save the changes?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#2C5DFE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSave(true)
        setIsRead(false)
        updateEr({ orgId, code }, body)
      }
    })
  }
  const updateEr = async (er, body) => {
    const result = await updateErAPI(er, body)
    if (!result) return
    if (result.status) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        setIsRead(true)
        getEmpsJobs()
      })
    } else {
      Error_false(result)
    }
    setIsSave(false)
    setIsRead(false)
  }

  const createEr = async (body) => {
    const result = await createErAPI(body)
    if (!result) return
    setIsSave(false)
    if (result.status) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        setIsRead(true)
        getEmpsJobs()
      })
    }
    setIsRead(false)
  }

  useEffect(() => {
    if (erTypes.length > 0 && provinces.length > 0 && orgId && code) {
      getEmpsJobs()
    }
  }, [erTypes, provinces, setValue, orgId, code])

  const getEmpsJobs = async () => {
    try {
      const resp = await getEmergencyAPI({ orgId, code })
      if (!resp) return

      if (resp.status) {
        if (resp.result.length > 0) {
          setDataDetail(resp.result[0])
          const d = resp.result[0]

          fnSetDataDetail(d)
        }
      }
    } catch (error) {
      setProvincId(0)
    }
  }
  const fnSetDataDetail = (d) => {
    setValue('erName', d?.er_name ?? '')
    setValue('erMobilePhone', d?.mobile_phone ?? '')
    const newRelation = erTypes.find((v) => v.label === d?.relation_name)
    setValue('erRelationId', newRelation ?? {})

    const newProvince = provinces.find((v) => v.label === d?.province)
    if (newProvince) {
      fnDistricts(newProvince.value, d)
      setProvincId(newProvince.value)
    }

    setValue('erProvince', newProvince)
    setValue('erAddress', d?.address ?? '')

    setValue('erPostCode', d?.post_code ?? '')
    setValue('erHomePhone', d?.home_phone ?? '')
  }
  const fnDistricts = async (proId, dv) => {
    if (proId) {
      const res = await getDistrictsAPI(proId)
      if (!res) return

      if (res.result.length > 0) {
        const cr_districtsNew = res.result.find(
          (d) => d.AMPHUR_NAME === dv.district
        )
        setDistrictId(cr_districtsNew?.AMPHUR_ID)
        setValue('erDistric', {
          value: cr_districtsNew?.AMPHUR_ID,
          label: cr_districtsNew?.AMPHUR_NAME
        })
        setError('erDistric', cr_districtsNew)

        fnSub_district(cr_districtsNew?.AMPHUR_ID, dv)
      }
    }
  }
  const fnSub_district = async (d, dv) => {
    if (d) {
      const res = await getSubdistrictsAPI(d)
      if (!res) return
      if (res.result.length > 0) {
        const cr_subDistrictsNew = res.result.find(
          (d) => d.DISTRICT_NAME === dv.sub_district
        )
        setValue('erSubDistric', {
          value: cr_subDistrictsNew?.DISTRICT_ID,
          label: cr_subDistrictsNew?.DISTRICT_NAME
        })
        setError('erSubDistric', cr_subDistrictsNew)
      }
    }
  }
  const roleId = useSelector((state) => state.roleReducer.role)
  const profileId = useSelector((state) => state.loginReducer.profile)
  const roles = CheckUserAdmin(profileId.roles, roleId)

  const options = { uppercase: true, numericOnly: true }

  const fnCancle = () => {
    fnSetDataDetail(dataDetail)
  }

  return (
    <Form className="row" onSubmit={handleSubmit(onSubmit)}>
      <Col xl={12} className="d-flex justify-content-between">
        <span className="my-auto text-primary">Emergency Contact</span>
        {roles?.status_id === 1 && (
          <>
            {/* {dataDetail ? (
              <ButtonSummit
                fnCancle={fnCancle}
                isRead={isRead}
                setIsRead={setIsRead}
                isSave={isSave}
                handleSubmit={handleSubmit(onSubmitEdit)}
              />
            ) : (
             
            )} */}
            <ButtonSummit
              fnCancle={fnCancle}
              isRead={isRead}
              setIsRead={setIsRead}
              isSave={isSave}
              handleSubmit={handleSubmit(dataDetail ? onSubmitEdit : onSubmit)}
            />
          </>
        )}
      </Col>
      <ColFrom>
        <LabelCustomSmall
          className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
        >
          ชื่อ-สกุล
        </LabelCustomSmall>
        {isRead === false ? (
          <Controller
            name={'erName'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control
                disabled={isRead}
                maxLength={300}
                value={value}
                onChange={onChange}
              />
            )}
          />
        ) : (
          <div className="fw-light small">{dataDetail?.er_name ?? '-'}</div>
        )}
        {errors.erName?.message && (
          <span className="text-danger small fw-light">
            {errors.erName.message}
          </span>
        )}
      </ColFrom>

      <ColFrom>
        <LabelCustomSmall
          className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
        >
          ความสัมพันธ์
        </LabelCustomSmall>
        {isRead === false ? (
          <Controller
            name={'erRelationId'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Autocomplete
                disabled={isRead}
                // placeholder="Select organization"
                options={erTypes}
                value={value}
                onChange={onChange}
              />
            )}
          />
        ) : (
          <div className="fw-light small">
            {dataDetail?.relation_name ?? '-'}
          </div>
        )}
        {errors.erRelationId?.message && (
          <span className="text-danger small fw-light">
            {errors.erRelationId.message}
          </span>
        )}
      </ColFrom>
      <ColFrom>
        <LabelCustomSmall
          className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
        >
          เบอร์โทรศัพท์
        </LabelCustomSmall>
        {isRead === false ? (
          <Controller
            name={'erMobilePhone'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <InputPhone disabled={isRead} value={value} onChange={onChange} />
            )}
          />
        ) : (
          <div className="fw-light small">
            {dataDetail?.mobile_phone ?? '-'}
          </div>
        )}
        {errors.erMobilePhone && (
          <span className="text-danger small fw-light">
            {errors.erMobilePhone.message}
          </span>
        )}
      </ColFrom>
      <ColFrom>
        <LabelCustomSmall
          className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
        >
          ที่อยู่
        </LabelCustomSmall>
        {isRead === false ? (
          <Controller
            name={'erAddress'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control
                disabled={isRead}
                maxLength={300}
                value={value}
                onChange={onChange}
              />
            )}
          />
        ) : (
          <div className="fw-light small">{dataDetail?.address ?? '-'}</div>
        )}
        {errors.erAddress && (
          <span className="text-danger small fw-light">
            {errors.erAddress.message}
          </span>
        )}
      </ColFrom>

      <ColFrom>
        <LabelCustomSmall
          className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
        >
          จังหวัด
        </LabelCustomSmall>
        {isRead === false ? (
          <Controller
            name={'erProvince'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Autocomplete
                disabled={isRead}
                options={provinces}
                value={value}
                onChange={(data) => {
                  setValue('erProvince', data)
                  setError('erProvince', false)
                  setProvincId(data.value)
                  setDistrictId(0)

                  setValue('erDistric')
                  setError('erDistric', true)
                  setValue('erSubDistric')
                  setError('erSubDistric', true)
                }}
              />
            )}
          />
        ) : (
          <div className="fw-light small">{dataDetail?.province ?? '-'}</div>
        )}
        {errors.erProvince?.message && (
          <span className="text-danger small fw-light">
            {errors.erProvince.message}
          </span>
        )}
      </ColFrom>
      <ColFrom>
        <LabelCustomSmall
          className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
        >
          อำเภอ/เขต
        </LabelCustomSmall>
        {isRead === false ? (
          <Controller
            name={'erDistric'}
            control={control}
            render={({ field: { value = '' } }) => (
              <Autocomplete
                disabled={!isRead ? (provincId > 0 ? false : true) : true}
                options={districts}
                value={value}
                onChange={(data) => {
                  setValue('erDistric', data)
                  setError('erDistric', false)
                  setDistrictId(data.value)

                  setValue('erSubDistric')
                  setError('erSubDistric', true)
                }}
              />
            )}
          />
        ) : (
          <div className="fw-light small">{dataDetail?.district ?? '-'}</div>
        )}
        {errors.erDistric?.message && (
          <span className="text-danger small fw-light">
            {errors.erDistric.message}
          </span>
        )}
      </ColFrom>
      <ColFrom>
        <LabelCustomSmall
          className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
        >
          ตำบล/แขวง
        </LabelCustomSmall>
        {isRead === false ? (
          <Controller
            name={'erSubDistric'}
            control={control}
            render={({ field: { value = '' } }) => (
              <Autocomplete
                disabled={!isRead ? (districtId > 0 ? false : true) : true}
                options={subDistricts}
                value={value}
                onChange={(d) => {
                  setValue('erPostCode', d.code)
                  setValue('erSubDistric', d)

                  setError('erPostCode', false)
                  setError('erSubDistric', false)
                }}
              />
            )}
          />
        ) : (
          <div className="fw-light small">
            {dataDetail?.sub_district ?? '-'}
          </div>
        )}
        {errors.erSubDistric?.message && (
          <span className="text-danger small fw-light">
            {errors.erSubDistric.message}
          </span>
        )}
      </ColFrom>
      <ColFrom>
        <LabelCustomSmall
          className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
        >
          รหัสไปรษณีย์
        </LabelCustomSmall>
        {isRead === false ? (
          <Controller
            name={'erPostCode'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              // <Form.Control
              //   disabled={isRead}
              //   maxLength={300}
              //   value={value}
              //   onChange={onChange}
              // />
              <Cleave
                className="form-control"
                disabled={isRead}
                value={value}
                onChange={onChange}
                options={options}
                id="prefix"
                maxLength={5}
              />
            )}
          />
        ) : (
          <div className="fw-light small">{dataDetail?.post_code ?? '-'}</div>
        )}
        {errors.erPostCode?.message && (
          <span className="text-danger small fw-light">
            {errors.erPostCode.message}
          </span>
        )}
      </ColFrom>
      <ColFrom>
        <LabelCustomSmall
          className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
        >
          หมายเลขโทรศัพท์บ้าน{' '}
          {isRead === false ? (
            <span className="text-warning">(ถ้ามี)</span>
          ) : (
            <></>
          )}{' '}
        </LabelCustomSmall>
        {isRead === false ? (
          <Controller
            name={'erHomePhone'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control
                disabled={isRead}
                maxLength={300}
                value={value}
                onChange={onChange}
                onKeyDown={handleKeyDownNum}
              />
            )}
          />
        ) : (
          <div className="fw-light small">{dataDetail?.home_phone ?? '-'}</div>
        )}
      </ColFrom>
    </Form>
  )
}

const ColFrom = (props) => {
  const { children, className, ...other } = props

  return (
    <Col xl={3} xs={4} md={3} className={`mb-3 ${className}`} {...other}>
      {children}
    </Col>
  )
}
export default EmergencyContact
